export enum CourseLevel {
  HIGHER = 'HIGHER',
  SAME = 'SAME',
  LOWER = 'LOWER',
  NO_UK_STUDY = 'NO_UK_STUDY',
}
